<!-- full will add the number input. Secondary class removes the number input when space is limited -->
<div class="p-inputgroup w-min" *ngIf="productId">
  <button type="button" pButton [icon]="faIcon" [label]="_label | translate" (click)="onAddToCart()"></button>
  <p-inputNumber
    class="secondary p-button-secondary"
    [(ngModel)]="quantity"
    [min]="1"
    [showButtons]="true"
    (keyDown.enter)="onAddToCart()"
    [ngClass]="{ hidden: iconOnly }"
  ></p-inputNumber>
</div>
